import styled from '@emotion/styled';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';

export const Wrapper = styled('div', { shouldForwardProp: (prop) => prop !== 'start' })<{start?:boolean}>`
    position: fixed;
    top:0;
    left:0;
    width:100vw;
    height:100vh;
    z-index: 1000;
`; 

export const Container = styled.div`
    position: relative;
    display: grid;
    grid-template-rows: 1fr 1.8fr 1fr;
    flex-direction: column;
    align-items: center;
    height:100%;
    padding:100px;
    z-index: 12;

    ${mq(Devices.mobile)}{
        padding:10px;
    }
`;

export const Background = styled.div`
    position: absolute;
    height:100vh;
    width:100vw;
    top:0;
    left:0;
    z-index: 1;
    background:#F7EECB;

`; 

export const BadgeRow = styled.div<{col?:boolean}>`
    height:100%;
    width:100%;
    display: flex;
    flex-direction: ${props => props.col?"unset":"column"};
    justify-content: ${props => props.col?"center":"unset"};
    gap: ${props => props.col?"120px":"unset"};
    align-items: center;

    ${mq(Devices.mobile)}{
        gap: ${props => props.col?"0":"unset"};
    }

    svg{
        height:100%;
        max-height: 26vh;
    }
`; 

export const ScreenTitle = styled.span`
    font-size: 20px;
    color:#FA505E;
    font-weight: 700;
    margin-top: auto;
`; 

export const BadgeTitle = styled.span`
    font-size: 110px;
    color:#2A848E;
    font-weight: 700;
    text-align: center;

    ${mq(Devices.mobile)}{
        font-size: 12vw;
        line-height: 17vw;
    }
`; 

export const BadgeDescription = styled.div`
    font-size: 20px;
    color:#171717;
    font-weight: 700;
    max-width: 550px;
    text-align: center;
`; 